import { render, staticRenderFns } from "./PartnerProductPurchasedCard.vue?vue&type=template&id=2c3a3976&"
import script from "./PartnerProductPurchasedCard.vue?vue&type=script&lang=ts&"
export * from "./PartnerProductPurchasedCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports